document.addEventListener('DOMContentLoaded', () => {
  const readStorage = (key) => {
    try {
      return JSON.parse(localStorage.getItem(key) || '[]');
    } catch (error) {
      return [];
    }
  };

  const writeStorage = (key, values) => {
    localStorage.setItem(key, JSON.stringify(values));
  };

  const syncUtilityButtons = (selector, storageKey) => {
    const buttons = document.querySelectorAll(selector);
    if (!buttons.length) return;

    const refreshButtons = (stored) => {
      buttons.forEach((button) => {
        const productId = button.dataset.productId;
        if (!productId) return;
        button.setAttribute('aria-pressed', stored.includes(productId) ? 'true' : 'false');
      });
    };

    refreshButtons(readStorage(storageKey));

    buttons.forEach((button) => {
      const productId = button.dataset.productId;
      if (!productId) return;

      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        let next = readStorage(storageKey);
        if (next.includes(productId)) {
          next = next.filter((id) => id !== productId);
        } else {
          next = [...next, productId];
        }

        writeStorage(storageKey, next);
        refreshButtons(next);
      });
    });
  };

  syncUtilityButtons('[data-hue-wishlist]', 'hue-wishlist');
  syncUtilityButtons('[data-hue-compare]', 'hue-compare');

  document.querySelectorAll('[data-hue-tabs]').forEach((tabsRoot) => {
    const tabs = tabsRoot.querySelectorAll('[data-hue-tab][role="tab"]');
    const panels = tabsRoot.querySelectorAll('[data-hue-tab-panel][role="tabpanel"]');
    const accordionToggles = tabsRoot.querySelectorAll('.hue-product-tabs__accordion-toggle');
    const accordionPanels = tabsRoot.querySelectorAll('.hue-product-tabs__accordion-panel');

    const activateTab = (tabName) => {
      tabs.forEach((tab) => {
        const isActive = tab.dataset.hueTab === tabName;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        const isActive = panel.dataset.hueTabPanel === tabName;
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        activateTab(tab.dataset.hueTab);
      });
    });

    accordionToggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const tabName = toggle.dataset.hueTab;
        const panel = tabsRoot.querySelector(
          `.hue-product-tabs__accordion-panel[data-hue-tab-panel="${tabName}"]`
        );
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';

        accordionToggles.forEach((otherToggle) => {
          otherToggle.setAttribute('aria-expanded', 'false');
        });
        accordionPanels.forEach((otherPanel) => {
          otherPanel.setAttribute('aria-hidden', 'true');
        });

        if (!isOpen && panel) {
          toggle.setAttribute('aria-expanded', 'true');
          panel.setAttribute('aria-hidden', 'false');
        }
      });
    });
  });

  document.querySelectorAll('[data-vehicle-finder]').forEach((form) => {
    const pairsScript = form.querySelector('[data-vehicle-pairs]');
    const brandSelect = form.querySelector('[data-vehicle-filter="marca"]');
    const modelSelect = form.querySelector('[data-vehicle-filter="modelo"]');
    const filterFields = Array.from(form.querySelectorAll('[data-vehicle-metafield]'));

    if (!brandSelect || !modelSelect) return;

    let brandModels = {};

    if (pairsScript) {
      try {
        const pairs = JSON.parse(pairsScript.textContent || '[]');
        pairs.forEach(({ marca, modelo }) => {
          if (!marca || !modelo) return;
          if (!brandModels[marca]) brandModels[marca] = new Set();
          brandModels[marca].add(modelo);
        });
        Object.keys(brandModels).forEach((marca) => {
          brandModels[marca] = Array.from(brandModels[marca]).sort((a, b) =>
            a.localeCompare(b, 'es', { sensitivity: 'base' })
          );
        });
      } catch (error) {
        brandModels = {};
      }
    }

    const sortValues = (values) =>
      values.sort((a, b) => a.localeCompare(b, 'es', { sensitivity: 'base' }));

    const populateModels = (brand, selectedModel) => {
      modelSelect.innerHTML = '<option value="">Todos</option>';

      if (!brand) {
        modelSelect.disabled = true;
        return;
      }

      let models = brandModels[brand] || [];
      if (selectedModel && !models.includes(selectedModel)) {
        models = sortValues([...models, selectedModel]);
      }

      models.forEach((model) => {
        const option = document.createElement('option');
        option.value = model;
        option.textContent = model;
        if (selectedModel && selectedModel === model) {
          option.selected = true;
        }
        modelSelect.appendChild(option);
      });

      modelSelect.disabled = models.length === 0;
    };

    const selectedModel = modelSelect.dataset.vehicleSelectedModel || modelSelect.value;
    populateModels(brandSelect.value, selectedModel);

    brandSelect.addEventListener('change', () => {
      populateModels(brandSelect.value, '');
    });

    const restoreSubmitDisabledFields = () => {
      filterFields.forEach((field) => {
        if (field.dataset.vehicleDisabledForSubmit === 'true') {
          field.disabled = false;
          delete field.dataset.vehicleDisabledForSubmit;
        }
      });

      populateModels(brandSelect.value, modelSelect.dataset.vehicleSelectedModel || modelSelect.value);
    };

    window.addEventListener('pageshow', restoreSubmitDisabledFields);

    form.addEventListener('submit', () => {
      filterFields.forEach((field) => {
        delete field.dataset.vehicleDisabledForSubmit;
        if (!field.value) {
          field.dataset.vehicleDisabledForSubmit = 'true';
          field.disabled = true;
        }
      });
    });
  });
});
